import type { Deal } from '../../../../services/shared-types';

export interface ValuationDealInfoProps {
  isFromModels?: boolean;
  deal?: Deal;
  isLoading?: boolean;
  onDealStageChange: (dealStageId: string) => Promise<void> | void;
  onSendFinalInvoice: () => Promise<void> | void;
}

export enum DealStageState {
  IDLE = 'idle',
  EDITING = 'editing',
  UPDATING = 'updating',
}
